import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { Layout } from '../constants';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    marginLeft: Layout.leftMargin,
    marginTop: Layout.topMargin,
    width: Theme.appWidth - Layout.leftMargin - Layout.rightMargin,
  },
  background: {
    flex: 1,
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  textSpacing: {
    marginBottom: Theme.px(8),
  },
  barContainer: {
    flexDirection: 'row',
    height: Theme.px(40),
    marginTop: Theme.px(66),
    width: '100%',
  },
  buttonsContainer: {
    flexDirection: 'row',
    marginTop: Theme.px(33),
  },
  controlsNode: {
    height: 1,
    width: 1,
  },
});
